module.exports = __webpack_public_path__ + "static/media/homescreen6x.02b51f25.png";